import React from "react";
import "./style.scss";

const Title = ({ text, startQuiz, text2 }) => {
  return <h2 className={`title ${startQuiz ? "startQuiz" : ""}`}>{text}</h2>;
};

export default Title;
